import { render, staticRenderFns } from "./station-detail.vue?vue&type=template&id=c5c25908&scoped=true&"
import script from "./station-detail.vue?vue&type=script&lang=js&"
export * from "./station-detail.vue?vue&type=script&lang=js&"
import style0 from "./station-detail.vue?vue&type=style&index=0&id=c5c25908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c25908",
  null
  
)

export default component.exports